<template>
  <div class="modal_background">
    <div class="register_company_modal">
      <div class="modal_header">
        <div class="modal_title">연락처 교환</div>
        <div class="modal_close_btn" @click="toggle_modal">
          <i class="fas fa-times" style="font-size:18px;line-height: 37px;"></i>
        </div>
      </div>
      <div class="modal_content">
        <div class="row">
          제안한 파트너와 연락처를 교환합니다.<br>
          <div class=""><span style="font-weight: bold">담당자</span> <input class="modal_input_text" v-model="person_in_charge"></div>
          <div class=""><span style="font-weight: bold">연락처</span> <input class="modal_input_text"  v-model="tel"> </div>
          <div class=""><span style="font-weight: bold">이메일</span> <input class="modal_input_text"  v-model="email"></div>
          <div class=""><span style="font-weight: bold; display: inline-block; float: left; margin-top: 8px;">메세지</span> 
          <textarea placeholder="메세지를 입력해주세요" v-model="message"></textarea></div>
        </div>
        <div class="modal_btn">
          <div class="confirm_btn" @click="register_form_submit()">교환하기</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:["item"],
  data() {
    return {
     person_in_charge:"" ,  tel:"" , email:"" , message:""
    };
  },
  methods: {
    toggle_modal() {
      this.$emit("toggle_modal");
    },
    register_form_submit() {
      this.$http
        .post(
          "app/exchange_card",
          this.qs({
            person_in_charge: this.person_in_charge,
            tel: this.tel,
            email: this.email,
            message:this.message,
            writer_id:this.item.writer_id,
            bid_id:this.item.bid_id,
          })
        )
        .then(res => {
          if (res.data.result == "success") {
            alert(
              "접수되었습니다. 감사합니다. "
            );
            this.toggle_modal();
          }
        })
    }
  }
};
</script>
<style scoped lang="scss">
.register_company_modal {
  position: fixed;
  left: 50%;
  margin-left: -200px;
  top: 200px;
  width: 400px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  z-index: 999999;
  .modal_header {
    width: 400px;
    height: 40px;
    line-height: 40px;
    background-color: #183262;
    text-align: center;
    color: #fff;
    position: relative;
    .modal_close_btn {
      position: absolute;
      top: 0px;
      right: 11px;
      cursor: pointer;
    }
    .modal_title{
      color:#fff;
      font-size: 14px;
    }
  }
  .modal_content {
    .modal_input_text{
      border: 1px solid #bbb;
      border-radius: 5px;
      margin: 5px;
      height: 30px;
      padding-left: 5px;
      margin-left: 20px;
      width : 290px;
    }
    padding: 20px 30px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.8);
    text-align: center;
    textarea{
      width: 290px;
      border: 1px solid #bbb;
      border-radius: 5px;
      margin: 5px;
      padding: 5px;
      margin-left: 23px;
    }
    .modal_input {
      border: solid 1px #0e3bff;
      background-color: #ffffff;
      width: 294px;
      height: 40px;
      font-size: 14px;
      padding-left: 20px;
      line-height: 40px;
      color: rgba(0, 0, 0, 0.8);
      margin-top: 20px;
    }
  }
  .modal_btn {
    text-align: center;   
    .confirm_btn {
      width: 160px;
      height: 40px;
      background-color: #0e3bff;
      color: #fff;
      cursor: pointer;
      text-align: center;
      line-height: 40px;
      font-size: 14px;
      display: inline-block;
    }
  }
  .form-group {
    width: 100%;
    text-align: left;
    input,
    textarea {
      width: 100%;
    }
  }
}
.modal_background {
  width: 100%;
  position: fixed;
  left:0px;
  top: 0px;
  min-height: 999px;
  background-color: rgba(0, 0, 0, 0.7);
}
</style>



// WEBPACK FOOTER //
// src/SharedComponents/Modal/MatchingPopup.vue